import { render, staticRenderFns } from "./ComicArticleRecord.vue?vue&type=template&id=08830ff6&scoped=true&"
import script from "./ComicArticleRecord.vue?vue&type=script&lang=js&"
export * from "./ComicArticleRecord.vue?vue&type=script&lang=js&"
import style0 from "./ComicArticleRecord.vue?vue&type=style&index=0&id=08830ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08830ff6",
  null
  
)

export default component.exports